import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "coloroutputmodes"
    }}>{`ColorOutputModes`}</h1>
    <p>{`Color output mode options for composites.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`COMPOSITE_LEAVE_UNCHANGED`}</strong>{` = 1668107349`}</p>
      <p parentName="blockquote">{`Sends a full-color version of the specified pages to the printer, preserving all color values in the original document. Note: Cannot simulate overprint when using this option.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`COMPOSITE_GRAY`}</strong>{` = 1668116583`}</p>
      <p parentName="blockquote">{`Sends grayscale versions of the specified pages to the printer.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`COMPOSITE_RGB`}</strong>{` = 1668108866`}</p>
      <p parentName="blockquote">{`Sends full-color versions of the specified pages to the printer.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`COMPOSITE_CMYK`}</strong>{` = 1668105035`}</p>
      <p parentName="blockquote">{`Sends full-color versions of the specified pages to the printer. Note: Available only for PostScript printers.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SEPARATIONS`}</strong>{` = 1936027745`}</p>
      <p parentName="blockquote">{`Sends PostScript information for each of the required separations to the printer. Note: Available only for PostScript printers.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`INRIP_SEPARATIONS`}</strong>{` = 1919512691`}</p>
      <p parentName="blockquote">{`Allows the printer to create color separations. Note: Valid only with a PostScript raster image processing (RIP) device.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      